import React, { PureComponent } from 'react';
import { Navbar, Nav, NavItem, Col, MenuItem, Row, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './Navigation.css';

class Navigation extends PureComponent {
  render() {
    return (
      <Row>
      <Col sm={12} xsHidden>
      <Navbar collapseOnSelect className="Navigation-Navbar">
        <Nav className="Navigation-Nav">
          <LinkContainer to="/about" className="Navigation-LinkContainer">
            <NavItem eventKey={1}>About</NavItem>
          </LinkContainer>
        </Nav>
        <Nav className="Navigation-Nav">
          <LinkContainer to="/gallery" className="Navigation-LinkContainer">
            <NavItem eventKey={2}>Gallery</NavItem>
          </LinkContainer>
        </Nav>
        <Nav className="Navigation-Nav">
          <LinkContainer to="/schedule" className="Navigation-LinkContainer">
            <NavItem eventKey={3}>Schedule</NavItem>
          </LinkContainer>
        </Nav>
        <Nav className="Navigation-Nav">
          <LinkContainer to="/contact" className="Navigation-LinkContainer">
            <NavItem eventKey={4}>Contact</NavItem>
          </LinkContainer>
        </Nav>
        <Nav className="Navigation-Nav">
          <NavItem onClick={() => { window.location = 'http://www.fortechicago.com'; }}>
            Forte Chicago
          </NavItem>
        </Nav>
          <Nav className="Navigation-NameTitle" pullRight>
            <LinkContainer to="/" className="Navigation-LinkContainer">
              <NavItem eventKey={5}>
                <div className="Navigation-Name">Susan Payne O&apos;Brien</div>
                <div className="Navigation-Title">Stage Director</div>
              </NavItem>
            </LinkContainer>
          </Nav>
      </Navbar>
      </Col>
        <Col xs={12} smHidden mdHidden lgHidden>
          <Navbar className="Navigation-Navbar">
            <Nav className="Navigation-NameTitle">
              <LinkContainer to="/" className="Navigation-LinkContainer">
                <NavItem eventKey={5}>
                  <div className="Navigation-Name">Susan Payne O&apos;Brien</div>
                  <div className="Navigation-Title">Stage Director</div>
                </NavItem>
              </LinkContainer>
            </Nav>
            <NavDropdown className="Navigation-Dropdown" title="Menu" pullRight>
              <LinkContainer to="/about" className="Navigation-LinkContainer">
                <MenuItem eventKey={1}>About</MenuItem>
              </LinkContainer>
              <LinkContainer to="/gallery" className="Navigation-LinkContainer">
                <MenuItem eventKey={2}>Gallery</MenuItem>
              </LinkContainer>
              <LinkContainer to="/schedule" className="Navigation-LinkContainer">
                <MenuItem eventKey={3}>Schedule</MenuItem>
              </LinkContainer>
              <LinkContainer to="/contact" className="Navigation-LinkContainer">
                <MenuItem eventKey={4}>Contact</MenuItem>
              </LinkContainer>
              <MenuItem onClick={() => { window.location = 'http://www.fortechicago.com'; }}>
                Forte Chicago
              </MenuItem>
            </NavDropdown>
          </Navbar>
        </Col>

      </Row>
    );
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.jsx